//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React from 'react';
import cancel from '../../icons/cancel.svg';
import { useTranslation } from 'react-i18next';
import { commonStyles } from '../../styles/commonStyles';
import { useNavigate } from 'react-router-dom';

type NoAccessPageProps = {
  message: string;
  icon: string;
};

function NoAccessPage({ message, icon }: Readonly<NoAccessPageProps>) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <div
        style={{ position: 'relative', ...commonStyles.noAccessPage }}
        id="id-no-access-page"
        data-testid="no-access-page"
      >
        <div
          style={{ width: '850px', backgroundColor: 'white', margin: '0 auto' }}
        >
          <div
            style={{
              ...commonStyles.noAccessContainer,
              position: 'absolute',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                position: 'relative',
                display: 'inline-block',
              }}
            >
              <img
                src={icon}
                alt="warning"
                id="warning-icon"
                style={{ marginBottom: '20px' }}
              />
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  ...commonStyles.cancelIconContainer,
                }}
                id="cancel-icon-container"
              >
                <div
                  onClick={() => navigate('/logout')}
                  style={commonStyles.cancelIcon}
                  id="cancel-icon"
                >
                  <img src={cancel} alt="cancel" id="cancel-image" />
                </div>
              </div>
            </div>
            <div
              style={commonStyles.noAccessTextRole}
              id="id-no-access-role-message"
              data-testid="no-access-role-message"
            >
              {message}
            </div>
            <div
              style={commonStyles.noAccessAdmin}
              id="id-no-access-admin-contact"
              data-testid="no-access-admin-contact"
            >
              {t('AdminContact')}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NoAccessPage;
